import { render } from "./DaiwariOutput.vue?vue&type=template&id=20ac9318&scoped=true"
import script from "./DaiwariOutput.vue?vue&type=script&lang=js"
export * from "./DaiwariOutput.vue?vue&type=script&lang=js"

import "./DaiwariOutput.vue?vue&type=style&index=0&id=20ac9318&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ac9318"]])

export default __exports__